import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* Footer & Contact */}
      <footer id="contact">
        <div className="container">
          <div className="footer-grid">
            <div className="footer-brand">
              <img
                src="https://app.formaxpay.com/assets/img/white_logo.png"
                alt="FORMAX PAY"
                style={{ height: 48, marginBottom: 12 }}
                onerror="this.style.display = 'none'"
              />
              <p>
                India's safe and secure platform for recharges and bill
                payments.
              </p>
              <p>
                <strong>Legal Name:</strong>
                <span className="legal-name">
                  {" "}
                  FORMAX IT SOLUTIONS PRIVATE LIMITED
                </span>
              </p>
              <p>
                <strong>CIN:</strong> U72900WB2018PTC228240 &nbsp;|&nbsp;
                <strong>GSTIN:</strong> 19AADCF5125F1ZT
              </p>
              {/* <div class="social-icons">
          <a href="#"><i class="fab fa-facebook"></i></a>
          <a href="#"><i class="fab fa-twitter"></i></a>
          <a href="#"><i class="fab fa-instagram"></i></a>
          <a href="#"><i class="fab fa-linkedin"></i></a>
        </div> */}
            </div>
            <div className="footer-links">
              <h4>Quick Links</h4>
              <ul>
                <li>
                  <a href="/">Home</a>
                </li>
                <li>
                  <a href="/services">Services</a>
                </li>
                <li>
                  <a href="/about-us">About Us</a>
                </li>
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/refund-policy">Refund Policy</a>
                </li>
                <li>
                  <a href="/terms-and-conditions">Terms and Conditions</a>
                </li>
              </ul>
            </div>
            <div className="footer-contact">
              <h4>Contact Us</h4>
              <p>
                <i className="fas fa-envelope" /> support@formaxpay.in
              </p>
              <p>
                <i className="fas fa-phone-alt" /> +91 7890090500
              </p>
              <p>
                <i className="fas fa-map-marker-alt" /> N0060, Mochpole, Near
                Junior School, Nabapally, Barasat, Kolkata - 700126, West
                Bengal, India
              </p>
            </div>
          </div>
          <div className="copyright">
            <p>
              © {currentYear} FORMAX PAY | FORMAX IT SOLUTIONS PRIVATE LIMITED |
              All Rights Reserved.
            </p>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
